import React from 'react';

const DangerAlert: React.FC = () => {
  return (
    <div className="danger-alert">
      {/* Left stripe box, with its own corners */}
      <div className="stripe-container left">
        <div className="corner top-left" />
        <div className="corner bottom-left" />
        <div className="danger-stripes" />
      </div>

      {/* Central “DANGER” panel */}

      <div className="danger-content">
        <div className="horizontal-line top" />
        <span className="danger-text">DANGER</span>
        <div className="horizontal-line bottom" />
      </div>


      {/* Right stripe box, with its own corners */}
      <div className="stripe-container right">
        <div className="corner top-right" />
        <div className="corner bottom-right" />
        <div className="danger-stripes" />
      </div>
    </div>
  );
};

export default DangerAlert;
